import AmountInputEN from './amount-input/locales/en.json'
import AmountInputPT from './amount-input/locales/pt-BR.json'
import ConnectionLatencyStatusEN from './connection-latency/locales/en.json'
import ConnectionLatencyStatusPT from './connection-latency/locales/pt-BR.json'
import CoreScheduledTagEN from './core-scheduled-tag/locales/en.json'
import CoreScheduledTagPT from './core-scheduled-tag/locales/pt-BR.json'
import DashboardCardsEN from './dashboard-cards/locales/en.json'
import DashboardCardsPT from './dashboard-cards/locales/pt-BR.json'
import DashboardColumnEN from './dashboard-columns/locales/en.json'
import DashboardColumnPT from './dashboard-columns/locales/pt-BR.json'
import DeliveryCardContentEN from './delivery-card-content/locales/en.json'
import DeliveryCardContentPT from './delivery-card-content/locales/pt-BR.json'
import DeliveryDetailProductCardEN from './delivery-detail-product-card/locales/en.json'
import DeliveryDetailProductCardPT from './delivery-detail-product-card/locales/pt-BR.json'
import DeviceOrientationWarningEN from './DeviceOrientationWarning/locales/en.json'
import DeviceOrientationWarningPT from './DeviceOrientationWarning/locales/pt-BR.json'
import EmptyStateEN from './empty-state/locales/en.json'
import EmptyStatePT from './empty-state/locales/pt-BR.json'
import ErrorBoundaryEN from './error-boundary/locales/en.json'
import ErrorBoundaryPT from './error-boundary/locales/pt-BR.json'
import PaginationEN from './pagination/locales/en.json'
import PaginationPT from './pagination/locales/pt-BR.json'
import PendingOrderCardEN from './pending-order-cards/locales/en.json'
import PendingOrderCardPT from './pending-order-cards/locales/pt-BR.json'
import PickingAmountTagsEN from './picking-amount-tags/locales/en.json'
import PickingAmountTagsPT from './picking-amount-tags/locales/pt-BR.json'
import PreparingOrderCardEN from './preparing-order-cards/locales/en.json'
import PreparingOrderCardPT from './preparing-order-cards/locales/pt-BR.json'
import ProductCardEN from './product-card/locales/en.json'
import ProductCardPT from './product-card/locales/pt-BR.json'
import ProductInformationEN from './product-information/locales/en.json'
import ProductInformationPT from './product-information/locales/pt-BR.json'
import ResumeProductCardEN from './resume-product-card/locales/en.json'
import ResumeProductCardPT from './resume-product-card/locales/pt-BR.json'
import SetIndentificationEN from './set-identification/locales/en.json'
import SetIndentificationPT from './set-identification/locales/pt-BR.json'
import SetShopperEN from './set-shopper/locales/en-US.json'
import SetShopperPT from './set-shopper/locales/pt-BR.json'
import StatusConnectionEN from './status-connection/locales/en.json'
import StatusConnectionPT from './status-connection/locales/pt-BR.json'
import TransferOrderCardEN from './transfer-order-card/locales/en.json'
import TransferOrderCardPT from './transfer-order-card/locales/pt-BR.json'
import UnauthorizedHubEN from './unauthorized-hub/locales/en.json'
import UnauthorizedHubPT from './unauthorized-hub/locales/pt-BR.json'

export const localesComponentsEN = {
  DashboardColumn: DashboardColumnEN,
  DashboardCard: DashboardCardsEN,
  PendingOrderCard: PendingOrderCardEN,
  EmptyState: EmptyStateEN,
  ProductCard: ProductCardEN,
  ErrorBoundary: ErrorBoundaryEN,
  AmountInput: AmountInputEN,
  ResumeProductCard: ResumeProductCardEN,
  UnauthorizedHub: UnauthorizedHubEN,
  DeliveryCardContent: DeliveryCardContentEN,
  StatusConnection: StatusConnectionEN,
  CoreScheduledTag: CoreScheduledTagEN,
  PreparingOrderCard: PreparingOrderCardEN,
  DeliveryDetailProductCard: DeliveryDetailProductCardEN,
  Pagination: PaginationEN,
  DeviceOrientationWarning: DeviceOrientationWarningEN,
  TransferOrderCard: TransferOrderCardEN,
  PickingAmountTags: PickingAmountTagsEN,
  SetShopper: SetShopperEN,
  ProductInformation: ProductInformationEN,
  SetIndentification: SetIndentificationEN,
  ConnectionLatencyStatus: ConnectionLatencyStatusEN,
}

export const localesComponentsPT = {
  DashboardColumn: DashboardColumnPT,
  DashboardCard: DashboardCardsPT,
  PendingOrderCard: PendingOrderCardPT,
  EmptyState: EmptyStatePT,
  ProductCard: ProductCardPT,
  ErrorBoundary: ErrorBoundaryPT,
  AmountInput: AmountInputPT,
  ResumeProductCard: ResumeProductCardPT,
  UnauthorizedHub: UnauthorizedHubPT,
  DeliveryCardContent: DeliveryCardContentPT,
  StatusConnection: StatusConnectionPT,
  CoreScheduledTag: CoreScheduledTagPT,
  PreparingOrderCard: PreparingOrderCardPT,
  DeliveryDetailProductCard: DeliveryDetailProductCardPT,
  Pagination: PaginationPT,
  DeviceOrientationWarning: DeviceOrientationWarningPT,
  TransferOrderCard: TransferOrderCardPT,
  PickingAmountTags: PickingAmountTagsPT,
  SetShopper: SetShopperPT,
  ProductInformation: ProductInformationPT,
  SetIndentification: SetIndentificationPT,
  ConnectionLatencyStatus: ConnectionLatencyStatusPT,
}
